import { OktaAuth } from "@okta/okta-auth-js";

const ciamAuth = new OktaAuth({
    clientId: process.env.REACT_APP_OKTA_CIAM_CLIENT_ID,
    issuer: process.env.REACT_APP_OKTA_CIAM_ISSUER,
    redirectUri: `${window.location.origin}/login/callback/`,
    scopes: ["openid", "profile", "email"],
    pkce: true,
});

export { ciamAuth };
